import PropTypes from 'prop-types'
import { Card, CardBody, Row, Col } from 'reactstrap'
import dollar_price from '../../general/DollarPrice'

const ShippingRateOption = ({ rate, isSelected, onSelect }) => {
  const handleClick = () => {
    onSelect(rate)
  }

  const cardClassName = `shipping-rate-card ${isSelected ? 'shipping-rate-card-selected' : ''}`

  return (
    <Card className={cardClassName} onClick={handleClick} style={{ cursor: 'pointer', marginBottom: '10px' }}>
      <CardBody>
        <Row>
          <Col xs={8}>
            <div>
              <strong>{rate.service_name}</strong>
            </div>
            {rate.estimated_days && (
              <div className="text-muted" style={{ fontSize: '0.875rem' }}>
                {rate.estimated_days} business day{rate.estimated_days !== 1 ? 's' : ''}
              </div>
            )}
          </Col>
          <Col xs={4} className="mf-text-right d-flex align-items-center justify-content-end">
            <strong>{dollar_price(rate.cost_in_cents)}</strong>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

ShippingRateOption.propTypes = {
  rate: PropTypes.shape({
    service_name: PropTypes.string.isRequired,
    service_code: PropTypes.string.isRequired,
    carrier_name: PropTypes.string.isRequired,
    cost_in_cents: PropTypes.number.isRequired,
    estimated_days: PropTypes.number, // Optional - flat rate shipping doesn't include this
    encrypted_cost: PropTypes.string.isRequired,
    carrier_service_id: PropTypes.number.isRequired
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default ShippingRateOption
